import { ApplicationTable } from "../application-table";

// The designer table now reuses the application table UI, since we want the
// same status chips, filtering, and actions previously provided under the
// Applications tab.
export const DesignerTable = () => <ApplicationTable />;
